import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';

export type GovermentIdReducerState = {
  documentOne: IOnboardingDocuments | null;
  documentTwo: IOnboardingDocuments | null;
};

export enum GovermentIdReducerCases {
  SET_DOCUMENTS = 'SET_DOCUMENTS',
  SET_FIRST_DOCUMENT = 'SET_FIRST_DOCUMENT',
  SET_SECOND_DOCUMENT = 'SET_SECOND_DOCUMENT',
  DELETE_DOCUMENTS = 'DELETE_DOCUMENTS',
}

export type DeleteGovernmentIdDocument = 'first' | 'second';

export interface GovermentIdReducerAction {
  type: GovermentIdReducerCases;
  payload: IOnboardingDocuments[] | DeleteGovernmentIdDocument;
}
